<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-dc-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-dc-' + id"
    :aria-controls="'collapse-dc-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_DC", 1) }}
  .collapse.show(
    :aria-labelledby="'heading-dc-' + id"
    :id="'collapse-dc-' + id"
  )
    .card-body.p-0
      .market-card-content
        .normal(v-if="mode == 0 || mode == 1")
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_HD") }}
              template(v-if="moreItems['dco']['HD'] && moreItems['dco']['HD'][5] != 0 && moreItems['dco']['HD'][5] != ''")
                OddsItem(:odds="moreItems['dco']['HD']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_HA") }}
              template(v-if="moreItems['dco']['HA'] && moreItems['dco']['HA'][5] != 0 && moreItems['dco']['HA'][5] != ''")
                OddsItem(:odds="moreItems['dco']['HA']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_DA") }}
              template(v-if="moreItems['dco']['DA'] && moreItems['dco']['DA'][5] != 0 && moreItems['dco']['DA'][5] != ''")
                OddsItem(:odds="moreItems['dco']['DA']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
              template(v-else)
                OddsDisabled
        .normal(v-if="$helpers.objSize(moreItems['dcho']) > 0 && (mode == 0 || mode == 2)")
          .normal-title {{ $t("ui.half_time") }}
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_HD") }}
              template(v-if="moreItems['dcho']['HD'] && moreItems['dcho']['HD'][5] != 0 && moreItems['dcho']['HD'][5] != ''")
                OddsItem(:odds="moreItems['dcho']['HD']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_HA") }}
              template(v-if="moreItems['dcho']['HA'] && moreItems['dcho']['HA'][5] != 0 && moreItems['dcho']['HA'][5] != ''")
                OddsItem(:odds="moreItems['dcho']['HA']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_DA") }}
              template(v-if="moreItems['dcho']['DA'] && moreItems['dcho']['DA'][5] != 0 && moreItems['dcho']['DA'][5] != ''")
                OddsItem(:odds="moreItems['dcho']['DA']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
              template(v-else)
                OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>